import { Box } from "@mui/material";

interface LoadingGemProps {
  compact?: boolean;
}

/**
 * An animated image rendered from `public/lottie/blue-diamond.json`, not a
 * Lottie canvas. dotLottie sizes its canvas from its own measurements, and one
 * taken while an ancestor is scaled shrank the gem until it disappeared.
 */
export const LoadingGem = ({ compact = false }: LoadingGemProps) => (
  <Box
    component="img"
    src="/animations/loading-gem.webp"
    role="status"
    aria-label="AI is responding"
    sx={{
      display: "block",
      width: compact ? "36px" : "50px",
      height: compact ? "36px" : "50px",
      marginLeft: compact ? 0 : "-5px",
    }}
  />
);
